import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
import { trackAddToCart } from '../utils/metaPixel';
export function CTASection() {
  return <section id="cta-final" className="py-24 bg-gradient-to-b from-transparent to-[#141414] border-t border-white/5" data-id="element-51">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-52">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-53">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-54">
            Empieza a automatizar hoy mismo
          </h2>
          <p className="text-xl text-gray-400 mb-10 max-w-2xl mx-auto" data-id="element-55">
            No dejes que las tareas repetitivas sigan consumiendo tu tiempo.
            Descarga el eBook y da el primer paso hacia un negocio más
            eficiente.
          </p>

          <div className="flex flex-col items-center gap-4" data-id="element-56">
            <CTAButton className="w-full sm:w-auto text-xl py-5 px-10" href="https://flujovital360.com/cart/45828712825028:1" onClick={() => trackAddToCart()} data-id="element-57">
              Comprar Ahora por $6.36
            </CTAButton>
            <p className="text-sm text-gray-500 mt-4 flex items-center gap-2" data-id="element-58">
              <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-59" />
              Acceso inmediato tras la descarga
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}